module.exports = "https://static.wanderu.com/static/media/chiku-peek.8d1aa185.png";